var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"noticia-not-found"},[_c('img',{attrs:{"src":require("../../../assets/imgs/search-not-found.svg"),"alt":"Notícia não encontrada!"}}),_c('p',[_vm._t("default")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }